import { Badge, Flex, Table } from "@/atoms"
import { Heading } from "@/molecules/Heading"
import { getColumnsTableAgent, getCommonColumnsTable } from "./getColumnsTable"
import { getAgentData, getCommonData } from "./getData"

import type { ViolationsTableProps } from "./RuleCardList.types"

export const ViolationsTable = (props: ViolationsTableProps) => {
  const { data, agentId } = props

  const isAgent = !!agentId
  const getColumnsTable = isAgent ? getColumnsTableAgent : getCommonColumnsTable
  const getData = isAgent ? getAgentData : getCommonData
  const dataSource = getData(
    isAgent
      ? data.agents.filter((agent: { id: string }) => agent.id === agentId)
      : data.agents
  )

  return (
    <Flex vertical gap={12}>
      <Flex gap={8} align="center">
        <Heading
          level={6}
          title={isAgent ? "Violations List" : "Violations Agents"}
        />
        <Badge count={dataSource.length} />
      </Flex>
      <Table<ReturnType<typeof getData>[number]>
        columns={getColumnsTable() as any}
        dataSource={dataSource}
        pagination={false}
      />
    </Flex>
  )
}
